import { render } from "./ChatAgentView.vue?vue&type=template&id=3ed2a127"
import script from "./ChatAgentScript.vue?vue&type=script&lang=js&external"
export * from "./ChatAgentScript.vue?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__